import script from "./related-project.vue?vue&type=script&lang=tsx&setup=true"
export * from "./related-project.vue?vue&type=script&lang=tsx&setup=true"

import "./related-project.vue?vue&type=style&index=0&id=6938a344&lang=scss"

const __exports__ = script;

export default __exports__